<template>
  <div
    id="inspire"
    class="fill-height"
  >
    <v-main>
      <v-container
        fluid
        class="fill-height"
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="sendForgottenEmail"
            >
              <v-card>
                <v-card-title>
                  Pozabljeno geslo
                </v-card-title>
                <v-card-text>
                  <div v-if="success">
                    Email s povezavo za ponastavitev gesla je bil poslan na {{ email }}.
                  </div>
                  <v-text-field
                    v-if="!success"
                    v-model="email"
                    prepend-icon="email"
                    name="email"
                    label="Email"
                    type="email"
                    :rules="emailRules"
                    required
                  />
                </v-card-text>
                <v-card-actions v-if="!success">
                  <v-spacer />
                  <v-btn
                    data-cy="login"
                    color="primary"
                    variant="outlined"
                    :disabled="!valid"
                    type="submit"
                  >
                    Ponastavi geslo
                  </v-btn>
                </v-card-actions>
                <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
                />
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
  import firebase from 'firebase/compat/app';

  export default {
    data: () => ({
      loading: false,
      valid: false,
      email: '',
      lastErrorCode: '',
      success: false,
    }),
    computed: {
      emailRules() {
        return [
          v => !!v || 'Vnos e-pošte je obvezen',
          v => /.+@.+/.test(v) || 'Vpišite veljaven e-poštni naslov',
          v => this.lastErrorCode !== 'auth/user-not-found' || 'Uporabnik ne obstaja'
        ]
      },
    },
    mounted() {
    },
    methods: {
      async sendForgottenEmail() {
        this.loading = true;

        if ((await this.$refs.form.validate()).valid) {
          try {
            await firebase
                .auth()
                .sendPasswordResetEmail(
                    this.email,
                    {
                      url: window.location.origin + '/login',
                      handleCodeInApp: false
                    }
                );
            this.success = true;
          } catch(e) {
            this.lastErrorCode = e.code;
            await this.$refs.form.validate();
            this.lastErrorCode = '';
          }
        }

        this.loading = false;
      }
    }
  }
</script>
